module.exports = "https://cdn.littlereply.com/tt/resource/finger@3x.2442bf38eee065de0a0f6da0c79c597f.png";